import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GlobalService, Licitacao, LicitacaoAudesp, RegistroPrecos, TipoObjetoLicitacao } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { LicitacaoAudespService } from '../../service/licitacao-audesp.service';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';

@Component({
  selector: 'app-licitacao-audesp-registro-preco',
  templateUrl: './licitacao-audesp-registro-preco.component.html'
})
export class LicitacaoAudespRegistroPrecoComponent extends BaseLicitacaoAudesp implements OnInit, OnChanges, OnDestroy {

  @Input() public registroPreco: 'S' | 'N';
  @Input() public entidade: LicitacaoAudesp;
  @Input() public licitacao: Licitacao;

  public arquivo: RegistroPrecos;
  public opcoesDivisaoLotes: { id: 'UNICA' | 'LOTES', nome: string }[];
  public opcoesTipoObjeto: { id: TipoObjetoLicitacao, nome: string }[];
  public opcoesObjeto: { id: number, nome: string }[];
  public opcoesModalidade: { id: number, nome: string }[];
  public opcoesNatureza: { id: number, nome: string }[];
  public opcoesTipoLicitacao: { id: number, nome: string }[];
  public opcoesLei1232006: { id: number, nome: string }[];
  public opcoesFundamentoDispensa: { id: number, nome: string }[];
  public opcoesFundamentoInexigibilidade: { id: number, nome: string }[];

  protected unsubscribe: Subject<void> = new Subject();

  constructor(private globalService: GlobalService,
    private audespService: LicitacaoAudespService,
  ) {
    super()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes['registroPreco'] || changes['licitacao'])) {
      if (this.entidade.id) {
        this.arquivo = this.entidade.arquivo as RegistroPrecos;
        this.carregarObjetosLicitacao();
      } else {
        if (!this.licitacao || !this.entidade) {
          this.iniciarObjeto();
        } else {
          this.importarInformacoes();
        }
      }
    }
  }

  ngOnInit(): void {
    this.opcoesTipoObjeto = this.globalService.obterTiposObjetoLicitacao();
    this.opcoesNatureza = this.globalService.obterNaturezaLicitacao();
    this.opcoesTipoLicitacao = this.globalService.obterTipoLicitacao()
    this.opcoesLei1232006 = this.globalService.obterLei1232006Licitacao();
    this.opcoesDivisaoLotes = [
      { id: 'UNICA', nome: 'Única' },
      { id: 'LOTES', nome: 'Dividida em lotes/itens' },
    ]
    this.opcoesModalidade = [
      { id: 1, nome: 'Concorrência' },
      { id: 2, nome: 'Concorrência Internacional' },
      { id: 10, nome: 'Contratação Direta - Dispensa de licitação' },
      { id: 11, nome: 'Contratação Direta - Inexigibilidade de licitação' },
      { id: 4, nome: 'Convite' },
      { id: 13, nome: 'Outra' },
      { id: 5, nome: 'Pregão Eletrônico' },
      { id: 6, nome: 'Pregão Presencial' },
      { id: 7, nome: 'Regime Diferenciado de Contratação - RDC' },
    ]
    this.opcoesFundamentoDispensa = [
      { id: 1, nome: 'Art. 24, I, Lei 8666/93' },
      { id: 2, nome: 'Art. 24, II, Lei 8666/93' },
      { id: 3, nome: 'Art. 24, III, Lei 8666/93' },
      { id: 4, nome: 'Art. 24, IV, Lei 8666/93' },
      { id: 5, nome: 'Art. 24, V, Lei 8666/93' },
      { id: 7, nome: 'Art. 24, VII, Lei 8666/93' },
      { id: 8, nome: 'Art. 24, VIII, Lei 8666/93' },
      { id: 10, nome: 'Art. 24, X, Lei 8666/93' },
      { id: 11, nome: 'Art. 24, XI, Lei 8666/93' },
      { id: 12, nome: 'Art. 24, XII, Lei 8666/93' },
      { id: 13, nome: 'Art. 24, XIII, Lei 8666/93' },
      { id: 14, nome: 'Art. 24, XIV, Lei 8666/93' },
      { id: 15, nome: 'Art. 24, XV, Lei 8666/93' },
      { id: 16, nome: 'Art. 24, XVI, Lei 8666/93' },
      { id: 17, nome: 'Art. 24, XVII, Lei 8666/93' },
      { id: 18, nome: 'Art. 24, XVIII, Lei 8666/93' },
      { id: 20, nome: 'Art. 24, XX, Lei 8666/93' },
      { id: 21, nome: 'Art. 24, XXI, Lei 8666/93' },
      { id: 22, nome: 'Art. 24, XXII, Lei 8666/93' },
      { id: 23, nome: 'Art. 24, XXIII, Lei 8666/93' },
      { id: 24, nome: 'Art. 24, XXIV, Lei 8666/93' },
      { id: 25, nome: 'Art. 24, XXV, Lei 8666/93' },
      { id: 26, nome: 'Art. 24, XXVI, Lei 8666/93' },
      { id: 27, nome: 'Art. 24, XXVII, Lei 8666/93' },
      { id: 31, nome: 'Art. 24, XXXI, Lei 8666/93' },
      { id: 32, nome: 'Art. 24, XXXII, Lei 8666/93' },
      { id: 33, nome: 'Art. 24, XXXIII, Lei 8666/93' },
      { id: 39, nome: 'Art. 24, XXX, Lei 8666/93' },
      { id: 40, nome: 'Art. 29, I, Lei 13.303/2016' },
      { id: 41, nome: 'Art. 29, II, Lei 13.303/2016' },
      { id: 42, nome: 'Art. 29, III, Lei 13.303/2016' },
      { id: 43, nome: 'Art. 29, IV, Lei 13.303/2016' },
      { id: 44, nome: 'Art. 29, V, Lei 13.303/2016' },
      { id: 45, nome: 'Art. 29, VI, Lei 13.303/2016' },
      { id: 46, nome: 'Art. 29, VII, Lei 13.303/2016' },
      { id: 47, nome: 'Art. 29, VIII, Lei 13.303/2016' },
      { id: 48, nome: 'Art. 29, IX, Lei 13.303/2016' },
      { id: 49, nome: 'Art. 29, X, Lei 13.303/2016' },
      { id: 50, nome: 'Art. 29, XI, Lei 13.303/2016' },
      { id: 51, nome: 'Art. 29, XII, Lei 13.303/2016' },
      { id: 52, nome: 'Art. 29, XIII, Lei 13.303/2016' },
      { id: 53, nome: 'Art. 29, XIV, Lei 13.303/2016' },
      { id: 54, nome: 'Art. 29, XV, Lei 13.303/2016' },
      { id: 38, nome: 'Chamada Publica - Lei Federal 11.9847/2009' },
      { id: 903, nome: 'Outro - fundamento legal' },
    ]
    this.opcoesFundamentoInexigibilidade = [
      { id: 34, nome: 'Art. 25. Caput' },
      { id: 35, nome: 'Art. 25, I, Lei 8666/93' },
      { id: 36, nome: 'Art. 25, II, Lei 8666/93' },
      { id: 37, nome: 'Art. 25, III, Lei 8666/93' },
      { id: 55, nome: 'Art. 30, I, Lei 13.303/2016' },
      { id: 56, nome: 'Art. 30, II, Lei 13.303/2016' },
      { id: 904, nome: 'Outro-Informar o fundamento legal' }
    ]

    this.iniciarObjeto();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

  public carregarObjetosLicitacao() {
    this.opcoesObjeto = this.globalService.obterObjetoLicitacao(this.arquivo.tipoObjeto);
    if (this.opcoesObjeto.length === 0) return;
    switch (this.arquivo.tipoObjeto) {
      case 'COMPRA_SERVICO':
        this.arquivo.ComprasServicos.ObjetoLicitacao = this.opcoesObjeto[0].id;
        break;
      case 'COMPRA_SERVICO_TI':
        this.arquivo.ComprasServicosTI.ObjetoLicitacaoTI = this.opcoesObjeto[0].id;
        break;
      case 'ENGENHARIA':
        this.arquivo.ObrasServicosEngenharia.ObjetoLicitacaoEN = this.opcoesObjeto[0].id;
        break;
    }
  }

  private iniciarObjeto() {
    this.entidade.arquivo = new RegistroPrecos();
    this.arquivo = this.entidade.arquivo;
    this.carregarObjetosLicitacao();
  }

  private importarInformacoes() {
    if (!this.licitacao || !this.entidade) return;
    this.audespService.importarDados('LICITACAO', this.licitacao.id).subscribe(res => {
      this.entidade.arquivo = res as RegistroPrecos;
      this.arquivo = this.entidade.arquivo;
      this.atribuirCodigo();
    })
  }

  public atribuirCodigo() {
    this.audespService.proximoCodigo('LICITACAO', this.login.exercicio.ano, this.login.orgao.id).subscribe(res => {
      if (res) this.arquivo.CodigoLicitacao = res;
    })
  }
}
